import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import all translation files
import enCommon from '../locales/en/common.json';
import enAuth from '../locales/en/auth.json';
import enAccounts from '../locales/en/accounts.json';
import enTransactions from '../locales/en/transactions.json';
import enValidation from '../locales/en/validation.json';

import idCommon from '../locales/id/common.json';
import idAuth from '../locales/id/auth.json';
import idAccounts from '../locales/id/accounts.json';
import idTransactions from '../locales/id/transactions.json';
import idValidation from '../locales/id/validation.json';

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    accounts: enAccounts,
    transactions: enTransactions,
    validation: enValidation,
  },
  id: {
    common: idCommon,
    auth: idAuth,
    accounts: idAccounts,
    transactions: idTransactions,
    validation: idValidation,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    load: 'languageOnly', // Load only 'en' instead of 'en-US'
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      convertDetectedLanguage: (lng) => lng.split('-')[0], // Convert 'en-US' to 'en'
    },
  });

export default i18n;
